if (window.addEventListener) {
  window.addEventListener("message", handleWindowEvent);
} else {
  window.attachEvent("onmessage", handleWindowEvent);
}
function handleWindowEvent(event) {
  try {
     
     if (event.origin.indexOf("livechat") >= 0) {
      //console.log("LiveChat Event ", event);
      // if (event.data.value.data.method == "applyFramesStyle") {
      //   if (event.data.value.data.args[0].maximizedFrameStyle.visibility == "hidden")
      //     console.log("Hide Chat");
      //   if (event.data.value.data.args[0].maximizedFrameStyle.visibility == "visible")
      //     console.log("Init Chat");
        
      // }
      if (event.data.value.data[0] == "send_event" && event.data.value.data[1].chat == "liveChatChatId") {
        console.log("Chat message sent", event.data.value);
        const storageChatId = sessionStorage.getItem("liveChatId");
        if (storageChatId == event.data.value.data[1].event.thread) {
          console.log("Chat Id exists ", event.data.value.data[1].event.thread)
          return;
        }
        sessionStorage.setItem("liveChatId", event.data.value.data[1].event.thread);
        window.dataLayer.push({
                  event: "chatInit",
                  chatId: event.data.value.data[1].event.id,
                  threadId: event.data.value.data[1].event.thread
              });
      }
    } 
  }
  catch(err) {
    console.warn("Unable to parse window event ", err)
  }
}

waitForElementToDisplay('form[data-testid="klaviyo-form-XUUJiV"]', function() {
      //console.log("FORM LOADED")
      const form = document.querySelector('form[data-testid="klaviyo-form-XUUJiV"]');
  
      if (form) {
          const input = form.querySelector('input'); // Assuming there's one input in the form
          const button = form.querySelector('button'); // Assuming there's one button in the form
  
          if (input && button) {
              button.addEventListener('click', (event) => {
                  // Get the input value
                  const inputValue = input.value;
                  console.log('Button clicked!');
                  console.log('Input value:', inputValue);
  
                   window.dataLayer.push({
                        event: "newsletterSubscription",
                        customerEmail: inputValue
                    });
              });
          } else {
              console.error('Input or button not found in the form!');
          }
      } else {
          console.error('Form not found!');
      }
        
      
    },100,9000);
